import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';
import { ADMIN_EMAIL } from '../utils/authConfig';
import '../styles.css';

function AuthSettings() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState({ configured: false, updatedAt: null });
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');

  const loadStatus = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await httpsCallable(functions, 'getStaffLoginStatus')();
      setStatus(response.data || { configured: false, updatedAt: null });
    } catch (error) {
      console.error('載入登入設定失敗:', error);
      setMessage('無法載入工作人員登入狀態');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadStatus();
  }, [loadStatus]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage('');

    if (password.length < 6) {
      setMessage('密碼至少需要 6 個字元');
      return;
    }
    if (password !== confirmPassword) {
      setMessage('兩次輸入的密碼不一致');
      return;
    }

    setIsSaving(true);
    try {
      const response = await httpsCallable(functions, 'setStaffLoginPassword')({ password });
      setStatus({
        configured: true,
        updatedAt: response.data?.updatedAt || new Date().toISOString(),
      });
      setPassword('');
      setConfirmPassword('');
      setMessage('工作人員登入密碼已更新');
    } catch (error) {
      console.error('更新工作人員密碼失敗:', error);
      setMessage(error.message || '密碼更新失敗');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '1.25rem' }}>
      <div style={{ width: '100%', maxWidth: '560px', margin: '0 auto' }}>
        <Link to="/" style={{ color: '#475569', textDecoration: 'none' }}>← 返回首頁</Link>
        <div style={{ marginTop: '1rem', background: '#fff', borderRadius: '18px', padding: '1.5rem', boxShadow: '0 12px 32px rgba(15,23,42,0.08)' }}>
          <h1 style={{ marginTop: 0, fontSize: '1.5rem' }}>後台登入設定</h1>
          <p style={{ color: '#64748b', lineHeight: 1.6 }}>
            管理員 <strong>{ADMIN_EMAIL}</strong> 可在這裡設定或更換工作人員共用密碼。
          </p>

          <div style={{ padding: '0.9rem 1rem', borderRadius: '12px', background: status.configured ? '#ecfdf5' : '#fff7ed', color: status.configured ? '#047857' : '#c2410c', marginBottom: '1.25rem' }}>
            {isLoading
              ? '正在讀取狀態...'
              : status.configured
                ? `工作人員密碼已設定${status.updatedAt ? `（${new Date(status.updatedAt).toLocaleString('zh-TW')}）` : ''}`
                : '尚未設定工作人員密碼'}
          </div>

          <form onSubmit={handleSubmit}>
            <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.45rem' }}>新密碼</label>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="new-password"
              placeholder="至少 6 個字元"
              style={{ width: '100%', boxSizing: 'border-box', padding: '0.8rem', border: '1px solid #cbd5e1', borderRadius: '10px', marginBottom: '1rem' }}
            />

            <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.45rem' }}>再輸入一次</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              autoComplete="new-password"
              placeholder="確認新密碼"
              style={{ width: '100%', boxSizing: 'border-box', padding: '0.8rem', border: '1px solid #cbd5e1', borderRadius: '10px', marginBottom: '1rem' }}
            />

            <button
              type="submit"
              disabled={isSaving}
              style={{ width: '100%', border: 'none', borderRadius: '10px', padding: '0.85rem', background: '#0f172a', color: '#fff', fontWeight: 700, cursor: isSaving ? 'wait' : 'pointer', opacity: isSaving ? 0.65 : 1 }}
            >
              {isSaving ? '更新中...' : status.configured ? '更換工作人員密碼' : '設定工作人員密碼'}
            </button>
          </form>

          {message && (
            <div style={{ marginTop: '1rem', color: message.includes('已更新') ? '#047857' : '#b91c1c', lineHeight: 1.5 }}>
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthSettings;
